import { render, staticRenderFns } from "./EnglishAutoCompleteUserSearch.vue?vue&type=template&id=50c71a67&scoped=true"
import script from "./EnglishAutoCompleteUserSearch.vue?vue&type=script&lang=ts"
export * from "./EnglishAutoCompleteUserSearch.vue?vue&type=script&lang=ts"
import style0 from "./EnglishAutoCompleteUserSearch.vue?vue&type=style&index=0&id=50c71a67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c71a67",
  null
  
)

export default component.exports